module.exports = __webpack_public_path__ + "img/experian.132735b4.png";